import script from "./UiPageHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./UiPageHeader.vue?vue&type=script&setup=true&lang=js"

import "./UiPageHeader.vue?vue&type=style&index=0&id=26b56ac0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-26b56ac0"]])

export default __exports__